<template>
  <div class="landing-page">
    <div class="landing-title">
      {{ $t('text.welcome_to_the_administration_section') }}
    </div>
    <el-row
      :gutter="30"
      :type="$root.screenWidth > 991 ? 'flex' : ''"
      id="quick-actions"
    >
      <el-col :xs="24" :md="12" class="profile-column">
        <div class="section-card hp-100">
          <div class="section-card-title profile-card-title">
            <span>{{ $t('text.profile') }}</span>
          </div>
          <div v-loading="loading">
            <div class="profile-item">
              <div class="left-side">
                <!-- <img src="@/assets/image/profile/home.png" /> -->
                <div class="icon-wrapper">
                  <svg
                    t="1752307800059"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="6994"
                  >
                    <path
                      d="M1002.7584 475.776L566.2784 39.68 537.1584 10.24a35.584 35.584 0 0 0-50.176 0L21.2544 475.776A72.192 72.192 0 0 0 0.0064 527.744a72.96 72.96 0 0 0 73.28 71.488h48v367.872h781.44V599.232h49.024c19.264 0 37.44-7.552 51.136-21.184 13.696-13.696 21.12-31.872 21.12-51.2 0-19.2-7.552-37.376-21.248-51.072z m-427.52 410.048H448.7744v-230.4h126.464v230.4z m246.144-367.872v367.872h-173.824V628.288a45.184 45.184 0 0 0-45.184-45.184H421.6384a45.184 45.184 0 0 0-45.184 45.184v257.536H202.6304V517.952H94.2144l417.92-417.6 26.048 26.112 391.68 391.488h-108.48z"
                      fill="currentColor"
                      p-id="6995"
                    ></path>
                  </svg>
                </div>
              </div>
              <div class="right-side">
                <div class="profile-title">
                  <span>{{ $t('text.name') }}</span>
                </div>
                <div class="profile-desc">
                  {{ profile.OrganisationName || '--' }}
                </div>
              </div>
            </div>
            <div class="profile-item">
              <div class="left-side">
                <!-- <img src="@/assets/image/profile/residents.png" /> -->
                <div class="icon-wrapper">
                  <svg
                    t="1752307855051"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="7990"
                  >
                    <path
                      d="M976 1024 304 1024c-26.496 0-48-21.504-48-48 0-68.864 29.056-152.192 77.76-222.944 40.704-59.104 90.688-103.616 144.672-129.6-23.808-21.632-44.288-48.032-60.512-78.112-26.016-48.256-39.744-104.064-39.744-161.344 0-79.616 26.208-154.816 73.792-211.776C501.632 112.736 568.416 80 640 80s138.368 32.736 188.032 92.224c47.584 56.96 73.792 132.192 73.792 211.776 0 57.28-13.728 113.056-39.744 161.344-16.224 30.112-36.704 56.48-60.512 78.112 53.984 25.984 104 70.496 144.672 129.6C994.944 823.808 1024 907.136 1024 976 1024 1002.496 1002.496 1024 976 1024zM358.08 928l563.84 0c-9.216-39.328-28.512-82.4-54.752-120.512-41.44-60.224-93.184-99.616-145.632-110.912-22.112-4.768-37.888-24.32-37.888-46.912l0-34.304c0-17.248 9.28-33.184 24.256-41.728 59.488-33.824 97.92-108.256 97.92-189.632 0-114.688-74.4-208-165.824-208s-165.824 93.312-165.824 208c0 81.344 38.432 155.808 97.92 189.632 15.008 8.544 24.256 24.448 24.256 41.728l0 34.304c0 22.624-15.776 42.144-37.888 46.912-52.448 11.296-104.192 50.688-145.632 110.912C386.592 845.6 367.296 888.672 358.08 928zM197.12 864l-95.04 0c9.216-39.328 28.512-82.4 54.752-120.512 41.472-60.224 93.184-99.616 145.632-110.912 22.112-4.768 37.888-24.32 37.888-46.912l0-34.304c0-17.248-9.28-33.184-24.256-41.728-59.488-33.824-97.92-108.256-97.92-189.632 0-114.688 74.4-208 165.824-208 6.24 0 12.416 0.448 18.496 1.312 26.368-29.344 56.224-53.184 88.64-71.008C457.952 25.056 421.632 16 384 16c-71.584 0-138.368 32.736-188.032 92.224C148.384 165.184 122.176 240.384 122.176 320c0 57.28 13.728 113.056 39.744 161.344 16.224 30.112 36.704 56.48 60.512 78.112-53.984 25.984-104 70.496-144.672 129.6C29.056 759.808 0 843.136 0 912c0 26.496 21.504 48 48 48l132.384 0C181.856 928.96 187.584 896.576 197.12 864z"
                      fill="currentColor"
                      p-id="7991"
                    ></path>
                  </svg>
                </div>
              </div>
              <div class="right-side">
                <div class="profile-title">
                  <span>{{
                    $t('text.patients', {
                      patients: $store.state.locale.patients
                    })
                  }}</span>
                </div>
                <div class="profile-desc">
                  {{
                    profile.Residents &&
                    (profile.Residents.Active || profile.Residents.Active === 0)
                      ? profile.Residents.Active
                      : '--'
                  }}
                  ({{ $t('text.active') }}),
                  {{
                    profile.Residents &&
                    (profile.Residents.Archived ||
                      profile.Residents.Archived === 0)
                      ? profile.Residents.Archived
                      : '--'
                  }}
                  ({{ $t('text.not_monitored') }})
                </div>
              </div>
            </div>
            <div class="profile-item">
              <div class="left-side">
                <!-- <img src="@/assets/image/profile/pods.png" /> -->
                <div class="icon-wrapper">
                  <svg
                    t="1752308964925"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="33384"
                  >
                    <path
                      d="M720 995.2H123.2c-28.8 0-51.2-24-51.2-51.2V268.8c0-28.8 24-51.2 51.2-51.2H720c28.8 0 51.2 24 51.2 51.2V944c0 27.2-24 51.2-51.2 51.2z m-584-64h571.2V280H136v651.2z"
                      fill="currentColor"
                      p-id="33385"
                    ></path>
                    <path
                      d="M920 745.6c-17.6 0-32-14.4-32-32V92.8H385.6c-17.6 0-32-14.4-32-32s14.4-32 32-32h513.6c11.2 0 27.2 0 41.6 12.8 4.8 4.8 12.8 16 12.8 30.4v641.6c-1.6 17.6-16 32-33.6 32z"
                      fill="currentColor"
                      p-id="33386"
                    ></path>
                  </svg>
                </div>
              </div>
              <div class="right-side">
                <div class="profile-title">
                  <span>{{ $t('text.pods') }}</span>
                </div>
                <div class="profile-desc">
                  {{ profile.Pods === 0 || profile.Pods ? profile.Pods : '--' }}
                </div>
              </div>
            </div>
            <div class="profile-item">
              <div class="left-side">
                <!-- <img src="@/assets/image/profile/nodes.png" /> -->
                <div class="icon-wrapper">
                  <svg
                    t="1752309298449"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="48577"
                  >
                    <path
                      d="M512 960c-247.04 0-448-200.96-448-448S264.96 64 512 64s448 200.96 448 448-200.96 448-448 448zM512 128c-211.74272 0-384 172.25728-384 384s172.25728 384 384 384 384-172.25728 384-384-172.25728-384-384-384z"
                      fill="currentColor"
                      p-id="48578"
                    ></path>
                    <path
                      d="M514.56 829.44c-175.04256 0-317.44-142.39744-317.44-317.44s142.39744-317.44 317.44-317.44 317.44 142.39744 317.44 317.44-142.39744 317.44-317.44 317.44z m0-589.53216c-150.03648 0-272.09216 122.05568-272.09216 272.09216s122.05568 272.09216 272.09216 272.09216c150.0416 0 272.09216-122.05568 272.09216-272.09216S664.6016 239.90784 514.56 239.90784z"
                      fill="currentColor"
                      p-id="48579"
                    ></path>
                  </svg>
                </div>
              </div>
              <div class="right-side">
                <div class="profile-title">
                  <span>{{ $t('text.nodes') }}</span>
                </div>
                <div class="profile-desc">
                  {{
                    profile.Nodes === 0 || profile.Nodes ? profile.Nodes : '--'
                  }}
                </div>
              </div>
            </div>
            <div class="profile-item">
              <div class="left-side">
                <!-- <img src="@/assets/image/profile/products.png" /> -->
                <div class="icon-wrapper">
                  <svg
                    t="1752307654749"
                    fill="currentColor"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="5997"
                  >
                    <path
                      d="M1024 216.3c0-72.9-59.3-132.1-132.1-132.1H132.1C59.3 84.1 0 143.4 0 216.3v232.4c0 24.7 1.9 49.6 5.5 73.8l-0.7 0.3 5.2 24.9c0.2 0.9 0.4 1.9 0.6 2.8l0.5 2.3c16.5 76.6 50.1 146.1 99.7 206.6 0.6 0.7 1.2 1.5 1.8 2.2 0.9 1.1 1.8 2.1 2.7 3.2 1.5 1.8 3 3.5 4.5 5.2l1.6 1.8c1.4 1.6 2.9 3.3 4.3 4.9l1.2 1.3c1.8 2 3.7 4.1 5.7 6.2l0.8 0.8c3.6 3.8 7.2 7.5 10.6 10.9l1.2 1.2 1.1 1.1c15.4 15.2 32 29.5 49.2 42.5l1.1 0.8c2.1 1.6 4.2 3.1 6.3 4.7 0.6 0.4 1.1 0.8 1.7 1.2l0.8 0.6c1.1 0.8 2.3 1.6 3.4 2.4C246.2 877 287 898 330.2 912.9c1.6 0.6 3.2 1.1 4.8 1.6l1.8 0.6c28.8 9.5 58.6 16.4 88.7 20.4l17.6 2.7 0.2-0.6c15.8 1.5 31.9 2.3 47.9 2.3h41.7c15.9 0 32-0.8 47.9-2.3l0.2 0.7 18.7-2.9c17.5-2.4 35-5.8 52.2-10l1-0.3c2.4-0.6 4.8-1.2 7.2-1.9 2-0.5 4-1.1 6-1.6l0.3-0.1c63.5-17.8 121.9-47.8 173.5-89.3l0.9-0.7c1.3-1 2.6-2.1 3.8-3.1 1.4-1.2 2.8-2.4 4.3-3.5 0.9-0.8 1.9-1.6 2.8-2.4 1.6-1.3 3.1-2.7 4.7-4l1.5-1.3c2-1.8 4.1-3.7 6.2-5.6l0.7-0.7c4.4-4.1 8.8-8.3 13.1-12.5l1.3-1.3 1-1c3.4-3.4 7-7.1 10.6-10.9l0.8-0.8c2-2.2 3.9-4.2 5.7-6.2l1.1-1.3c1.5-1.6 2.9-3.3 4.3-4.9l0.6-0.6c0.4-0.4 0.7-0.8 1.1-1.2 1.5-1.7 3-3.5 4.5-5.2 0.9-1.1 1.8-2.1 2.7-3.2 0.6-0.7 1.2-1.5 1.8-2.2 41-50 71.2-106.6 89.8-168.3 0.6-2.1 1.2-4.1 1.8-6.2l0.3-1.1c3.7-12.8 6.8-25.9 9.4-38.9l4.6-22.1-0.7-0.2c3.6-24.2 5.5-49.1 5.5-73.8V216.3zM883.8 553.5c22.3 0 44.5 2.8 66.1 8.3-18.2 66.9-52.8 129.2-100.3 180.4-48.9 52.7-110.4 92.7-177.9 115.7l-0.5 0.2c-1.4 0.5-2.8 0.9-4.2 1.4-0.6 0.2-1.1 0.4-1.7 0.6l-0.4 0.1c-1.7 0.6-3.4 1.1-5.2 1.6-1.4 0.4-2.7 0.8-4.1 1.2-0.7 0.2-1.3 0.4-2 0.6l-0.7 0.2c-1.5 0.4-3 0.9-4.5 1.3l-1.9 0.5c-2.2 0.6-4.5 1.2-6.7 1.8l-0.7 0.2c-2.3 0.6-4.6 1.2-7 1.7h-0.1c-2.8 0.7-5.6 1.3-8.4 1.9-3.4-17.1-5.2-34.7-5.2-52.3 0-146.3 119.1-265.4 265.4-265.4z m-743.6 0c146.3 0 265.4 119.1 265.4 265.4 0 17.6-1.7 35.2-5.2 52.3-2.8-0.6-5.6-1.2-8.4-1.9l-0.2-0.1c-2.3-0.5-4.5-1.1-6.8-1.7l-0.8-0.2c-2.2-0.6-4.4-1.1-6.5-1.7l-2.2-0.6c-1.3-0.4-2.7-0.8-4-1.1l-0.6-0.2c-0.8-0.2-1.7-0.5-2.5-0.7-0.6-0.2-1.2-0.4-1.7-0.5l-0.9-0.3c-2.6-0.8-5-1.5-7.2-2.3l-1-0.3c-68.7-22.4-131.4-62.3-181.3-115.4-48.4-51.6-83.7-114.6-102.1-182.3 21.4-5.6 43.6-8.4 66-8.4zM964.9 392H819.8c-26.1 0-47.4-21.3-47.4-47.4v-25.7c0-26.1 21.3-47.4 47.4-47.4H965V392z m-251.6-73.2v25.7c0 58.7 47.8 106.5 106.5 106.5H965c-0.1 17.6-1.3 35.4-3.5 52.9-25.2-6.2-51.3-9.3-77.5-9.3-86.7 0-168.2 33.7-229.4 95-61.3 61.3-95 142.8-95 229.4 0 20.3 1.9 40.7 5.7 60.7-10.7 0.8-21.6 1.2-32.3 1.2h-41.7c-10.7 0-21.6-0.4-32.3-1.2 3.8-19.9 5.7-40.3 5.7-60.7 0-86.7-33.7-168.2-95-229.4-61.3-61.3-142.8-95-229.4-95-26.2 0-52.3 3.1-77.5 9.3-2.2-17.5-3.4-35.2-3.5-52.9h145.2c58.7 0 106.5-47.7 106.5-106.4v-25.7c0-58.7-47.8-106.5-106.5-106.5H59.2c1-18.3 8.7-35.4 21.9-48.4 13.7-13.4 31.9-20.8 51-20.8h759.7c19.1 0 37.3 7.4 51 20.8 13.2 12.9 21 30 22 48.3h-145c-58.8 0-106.5 47.7-106.5 106.5z m-461.6 25.6c0 26.1-21.3 47.4-47.4 47.4H59.1V271.3h145.2c26.1 0 47.4 21.3 47.4 47.4v25.7z"
                      p-id="5998"
                    ></path>
                  </svg>
                </div>
              </div>
              <div class="right-side">
                <div class="profile-title">
                  <span>{{ $t('text.products') }}</span>
                </div>
                <div class="profile-desc">
                  <div v-if="profile.Products">
                    <div
                      v-for="item in profile.Products"
                      :key="item.ManufacturerName"
                    >
                      <span>{{ item.ManufacturerName }}</span> -
                      <span
                        v-for="(product, index) in item.Products"
                        :key="product"
                      >
                        {{ product }}
                        <span v-if="index !== item.Products.length - 1">,</span>
                      </span>
                    </div>
                  </div>
                  <div v-else>--</div>
                </div>
              </div>
            </div>
            <div class="profile-item">
              <div class="left-side">
                <!-- <img src="@/assets/image/profile/rounds.png" /> -->
                <div class="icon-wrapper">
                  <svg
                    t="1752309395972"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="49587"
                  >
                    <path
                      d="M512 74.666667C270.933333 74.666667 74.666667 270.933333 74.666667 512S270.933333 949.333333 512 949.333333 949.333333 753.066667 949.333333 512 753.066667 74.666667 512 74.666667z m0 810.666666c-204.8 0-373.333333-168.533333-373.333333-373.333333S307.2 138.666667 512 138.666667 885.333333 307.2 885.333333 512 716.8 885.333333 512 885.333333z"
                      fill="currentColor"
                      p-id="49588"
                    ></path>
                    <path
                      d="M695.466667 567.466667l-151.466667-70.4V277.333333c0-17.066667-14.933333-32-32-32s-32 14.933333-32 32v238.933334c0 12.8 6.4 23.466667 19.2 29.866666l170.666667 81.066667c4.266667 2.133333 8.533333 2.133333 12.8 2.133333 12.8 0 23.466667-6.4 29.866666-19.2 6.4-14.933333 0-34.133333-17.066666-42.666666z"
                      fill="currentColor"
                      p-id="49589"
                    ></path>
                  </svg>
                </div>
              </div>
              <div class="right-side">
                <div class="profile-title">
                  <span>{{ $t('text.rounds') }}</span>
                </div>
                <div class="profile-desc">
                  <div>
                    {{ $t('text.day').toLowerCase() | firstLetterCapitalize }}:
                    {{
                      profile.Rounds && profile.Rounds.Day
                        ? profile.Rounds.Day
                        : '--'
                    }}
                  </div>
                  <div>
                    {{
                      $t('text.night').toLowerCase() | firstLetterCapitalize
                    }}:
                    {{
                      profile.Rounds && profile.Rounds.Night
                        ? profile.Rounds.Night
                        : '--'
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col
        :xs="24"
        :md="12"
        v-if="
          p('Patients.Add') ||
            p('Patients.Edit') ||
            p('Users.Invite') ||
            p('Patients.Delete')
        "
      >
        <div class="section-card hp-100">
          <div class="section-card-title">
            <img
              class="title-icon"
              src="@/assets/image/quick-action-icon.png"
            />
            <span>{{ $t('text.quick_actions') }}</span>
          </div>
          <div
            v-for="action in quickActions"
            :key="action.title"
            class="quick-operate-item"
            @click="action.onClickAction(action.title, action.actionType)"
            v-show="p(action.permission)"
          >
            <div class="left-icon-wrapper v-h-center">
              <img
                :src="
                  require('@/assets/image/quick-operation-icon/' + action.icon)
                "
                :style="{ width: action.iconWidth + 'px' }"
              />
            </div>
            <div class="right-content">
              <div class="quick-operate-title">{{ action.title }}</div>
              <div class="quick-operate-desc">{{ action.desc }}</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <EditPatient ref="editPatient" />
    <UpdatePatientDeviceAndProucts ref="updatePatientDeviceAndProucts" />
    <InviteUserDialog ref="inviteUser" />
    <RemoveOrArchivePatient ref="removeOrArchivePatient" />
  </div>
</template>

<script>
import EditPatient from '@/components/manage/patients/EditPatient.vue'
import UpdatePatientDeviceAndProucts from '@/components/patients/quickActions/UpdatePatientDeviceAndProucts.vue'
import InviteUserDialog from '@/components/manage/user/InviteUserDialog.vue'
import RemoveOrArchivePatient from '@/components/manage/patients/RemoveOrArchivePatient.vue'
import { patientQuickActions } from '@/const'
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import moment from 'moment'
export default {
  data() {
    return {
      quickActions: [
        {
          title: this.$t('text.add_patient', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc:
            this.$t('text.add_patient_quick_action_desc', {
              patient: this.$store.state.locale.patient
            }) + '.',
          onClickAction: this.addPatient,
          icon: 'add-patient.png',
          iconWidth: 36,
          actionType: patientQuickActions.addPatient,
          permission: 'Patients.Add'
        },
        {
          title: this.$t('text.invite_user'),
          desc: this.$t('text.invite_user_quick_action_desc') + '.',
          onClickAction: this.inviteUser,
          icon: 'add-user.png',
          iconWidth: 39,
          actionType: null,
          permission: 'Users.Invite'
        },
        {
          title: this.$t('text.remove_or_archive_patient', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc:
            this.$t('text.remove_or_archive_patient_quick_action_desc', {
              patient: this.$store.state.locale.patient
            }) + '.',
          onClickAction: this.removeOrArchivePatient,
          icon: 'remove-or-archive-patient.png',
          iconWidth: 34,
          actionType: null,
          permission: 'Patients.Delete'
        },
        {
          title: this.$t('text.reassign_pod_to_patient', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc:
            this.$t('text.reassign_pod_quick_action_desc', {
              patient: this.$store.state.locale.patient
            }) + '.',
          onClickAction: this.updatePatientDeviceAndProucts,
          icon: 'reassign-pod.png',
          iconWidth: 36,
          actionType: patientQuickActions.assignPod,
          permission: 'Patients.Edit'
        },
        {
          title: this.$t('text.monitor_patient_with_a_node', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc:
            this.$t('text.monitor_patient_with_a_node_quick_action_desc', {
              patient: this.$store.state.locale.patient
            }) + '.',
          onClickAction: this.updatePatientDeviceAndProucts,
          icon: 'assign-node.png',
          iconWidth: 36,
          actionType: patientQuickActions.assignNode,
          permission: 'Patients.Edit'
        }
      ],
      loading: false,
      profile: {}
    }
  },
  components: {
    EditPatient,
    UpdatePatientDeviceAndProucts,
    InviteUserDialog,
    RemoveOrArchivePatient
  },
  mounted() {
    this.getOrganisationProfile()
  },
  methods: {
    getOrganisationProfile() {
      this.loading = true
      ApiService.GetOrganisationProfile(
        this.$store.getters[`user/selecteOrganisationId`]
      ).then(response => {
        this.loading = false
        if (response.data.success) {
          this.profile = response.data.data
          this.profile.Rounds = {
            Day:
              this.profile.Rounds.Day !== '-'
                ? moment(
                    moment().format('YYYY-MM-DD ') + this.profile.Rounds.Day
                  ).format('h A')
                : '-',
            Night:
              this.profile.Rounds.Night !== '-'
                ? moment(
                    moment().format('YYYY-MM-DD ') + this.profile.Rounds.Night
                  ).format('h A')
                : '-'
          }
        } else {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    },
    addPatient() {
      this.$refs.editPatient.openDialog()
    },
    updatePatientDeviceAndProucts(title, actionType) {
      this.$forceUpdate()
      this.$refs.updatePatientDeviceAndProucts.openDialog(title, actionType)
    },
    inviteUser() {
      this.$refs.inviteUser.openDialog()
    },
    removeOrArchivePatient() {
      this.$refs.removeOrArchivePatient.openDialog()
    }
  }
}
</script>
